import React from 'react';

class C18Input00 extends React.Component{
  constructor(props) {
    super(props);
    this.state={
    }
  }
  
  render(){
    return React.createElement("input",this.props)
  }
}
      
export default C18Input00;
